export default __webpack_public_path__ + "static/media/rfactorWallPaper.8503aec3.jpg";